"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";

import { openPwaInstallModal } from "./pwa-install-modal";

const MODAL_REGISTRY: Record<string, () => void> = {
  "pwa-install": openPwaInstallModal,
};

export function HandleModalUrlParam() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const modalId = searchParams.get("modal");
    if (!modalId) return;
    const opener = MODAL_REGISTRY[modalId];
    if (!opener) return;
    opener();
    // Strip the param so the modal doesn't reopen on every navigation
    // (the effect re-runs when pathname or searchParams change).
    const params = new URLSearchParams(searchParams.toString());
    params.delete("modal");
    const qs = params.toString();
    router.replace(`${pathname}${qs ? `?${qs}` : ""}`, { scroll: false });
  }, [pathname, searchParams, router]);

  return null;
}
